import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'aid-sidenav-footer-actions',
  template: `
    <div class="border actions full-width aid-layout-row aid-flex-100">
      @if (canDelete) {
        <div class="actions--border-right aid-flex-12">
          <button
            mat-icon-button
            class="actions__delete-button actions--color"
            (click)="delete.emit()"
          >
            <mat-icon class="actions__delete-icon" svgIcon="delete"></mat-icon>
          </button>
        </div>
      }
      <div class="actions--border-right aid-flex-44">
        <button
          mat-flat-button
          class="full-height full-width actions--color"
          (click)="cancel.emit()"
        >
          {{ 'cancel' | translate }}
        </button>
      </div>
      <div class="aid-flex">
        <button
          mat-flat-button
          class="full-height full-width"
          color="primary"
          [disabled]="disabled"
          (click)="save.emit()"
        >
          <div class="aid-layout-row aid-layout-align-center-center">
            @if (loading) {
              <mat-progress-spinner
                mode="indeterminate"
                [diameter]="24"
                color="white"
                [strokeWidth]="3"
              >
              </mat-progress-spinner>
            }
          </div>
          @if (!loading) {
            <span>{{ 'save' | translate }}</span>
          }
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./sidenav-footer-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SidenavFooterActionsComponent implements OnInit {
  @Input() disabled?: boolean;
  @Input() canDelete = false;
  @Input() loading?: boolean;

  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() delete = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
